<template>
  <v-container
    class="fill-height"
    fluid>
    <v-row
      align="center"
      justify="center">
      <v-col
        :cols="12"
        class="text-center">
        loading
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AuthProvider from '@/resources/AuthProvider'
import { mapActions } from 'vuex'
import { setAuthUser, clearAuth } from '@/assets/js/Authentication'

const authService = new AuthProvider()

export default {
  data () {
    return {
      loading: false
    }
  },
  mounted () {
    const { query } = this.$route
    clearAuth()
    if (query && query.token_reference) {
      this.login(query.token_reference)
    } else {
      setTimeout(() => {
        const uri = `${window.location.origin}${this.$route.path}`
        window.location.replace(`${process.env.VUE_APP_LOGIN}?callback_uri=${encodeURI(uri)}`)
      }, 1000)
    }
  },
  methods: {
    ...mapActions({
      setSnackBar: 'Style/setSnackbar'
    }),
    async login (token) {
      try {
        const { accessToken } = await authService.login(token)
        setAuthUser(accessToken)
        this.$router.push({ name: 'Home' })
        this.setSnackBar({
          value: true,
          message: 'Login Success',
          type: 'success'
        })
      } catch (err) {
        console.error(err)
        this.setSnackBar({
          value: true,
          message: 'เกิดข้อผิดพลาดกรุณา โหลดหน้าใหม่',
          type: 'error'
        })
      }
    }
  }
}
</script>
